/**
 * Keycloak realm roles in JWTs are not always normalized; compare case-insensitively.
 */
export function hasAnyRole(roles: string[] | undefined, ...candidates: string[]): boolean {
  if (!roles?.length || !candidates.length) return false;
  const normalized = roles.map((r) => r.toUpperCase());
  return candidates.some((c) => normalized.includes(c.toUpperCase()));
}
